import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { frFR } from '@mui/x-date-pickers/locales';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateTimePicker as MuiDateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import moment from "moment";

/* https://mui.com/x/react-date-pickers/getting-started/ */

export const DateTimePicker = (props) => {
    const {
        meta: { error },
        input,
        label,
        placeholder = 'DD/MM/YYYY',
    } = props;

    let locale = frFR.components.MuiLocalizationProvider.defaultProps.localeText;
    /* Props non traduite dans la lib */
    locale.datePickerDefaultToolbarTitle = 'Sélectionnez une date';

    return (
        <div data-id={`date-${input.name}`}>
            <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="fr" localeText={locale}>
                <MuiDateTimePicker
                    className={'w-100 bg-white'}
                    label={label}
                    value={
                        input.value && moment(input.value).isValid()
                            ? moment(input.value)
                            : null
                    }
                    onChange={(newValue) => {
                        input.onChange(newValue);
                        // Marquer que l'utilisateur a modifié la valeur
                        if (props.changeValue) {
                            props.changeValue('DemandeContrat[DateHeureEffetUserModified]', true);
                        }
                    }}

                    renderInput={(params) => {
                        params.inputProps.placeholder = placeholder;
                        params.InputProps.error = Boolean(error);
                        return <TextField {...params} />;
                    }}
                />
                {error && <small className={'alert alert-danger invalid-feedback d-block error'}>{error}</small>}
            </LocalizationProvider>
        </div>
    );
};
